module.exports = __webpack_public_path__ + "media/marketing_area/sundryscene-9fe204fb.png";